import { object } from 'yup';
import { GET_ALL_LEADS, GET_ALL_LEADS_LOADING } from '../type/type';
import axios from "axios";

const PROXY = process.env.REACT_APP_API_URL + 'api/';

export const getAllLeads = (queryObject) => async (dispatch) => {
    try {
        dispatch({ type: GET_ALL_LEADS_LOADING });
        if (Object.keys(queryObject).length > 0) {
            const res = await axios.get(PROXY + 'leads/all', { params: queryObject });
            dispatch({
                type: GET_ALL_LEADS,
                payload: res.data.result,
            });
            return res;
        }
    }
    catch (err) {
        return err
    }
};

export const getleadViewDetails = (id, apiType) => async (dispatch) => {
    const res = await axios.get(PROXY + `${apiType}` + id);
    return res;
};

export const getAllStatusFields = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'leads/status/fields');
    return res;
};

export const getFilterDropdownOptions = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'leads/filter-options');
    return res;
};

export const getFreshWorkFields = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'olaleads/freshworkBrand/fields');
    return res;
};

export const getleadDetails = (id) => async (dispatch) => {
    const res = await axios.get(PROXY + 'leads/getLeadJourney/' + id);
    return res;
};

export const getPincodeDirectoryFields = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'olaleads/pincode-directory/fields');
    return res;
};

export const getTenureDownpayRangeFields = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'olaleads/tenure-downpay-range/fields');
    return res;
};

export const downloadLeads = (queryParams, leadType) => async (dispatch) => {
    try {
        const filteredParams = Object.entries(queryParams)
            .filter(([_, value]) => value !== undefined && value !== null && value !== '')
            .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

        const searchParams = new URLSearchParams(filteredParams);

        // Return the axios promise directly
        return await axios.get(`${PROXY}leads/download/csv/${leadType}?${searchParams.toString()}`);
    }
    catch (err) {
        throw err;  // Rethrow the error so it can be caught in the .catch block
    }
};

export const uploadleads = (formData) => async (dispatch) => {
    const res = await axios.post(`${PROXY}` + `leads/upload/csv`, formData);
    return res;
};

export const getDealersAndAreas = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'olaleads/dealer-area/fields');
    return res
}

export const getBrandFields = () => async (dispatch) => {
    const res = await axios.get(PROXY + 'olaleads/brand/fields');
    return res || {};
}

export const uploadRetailLeads = (formData) => async (dispatch) => {
    const res = await axios.put(`${PROXY}leads/import-retailed-leads?company=revolt`, formData);
    return res;
};